import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClock, faExclamationTriangle, faHandPaper } from '@fortawesome/free-solid-svg-icons';
import abacusService from '../../services/abacusService';
import './AbacusSync.css';

// Where one document stands in Abacus. Documents are sent by themselves when
// accounting marks them collected, so there is no "send" button here: the line
// only says what happened, or what the document is waiting for and where to
// fix it. Finance people only; for anyone else the server says no and this
// line stays empty.
const LOOK = {
  SYNCED: { icon: faCheck, cls: 'abacus-sync-btn--success', words: (r) => `In Abacus${r.abacus_id ? ` · document ${r.abacus_id}` : ''}` },
  PENDING: { icon: faClock, cls: 'abacus-sync-btn--loading', words: () => 'Being sent to Abacus' },
  // The server's own words for the state ("Waiting for someone"): a waiting document may be one
  // Abacus may already hold (its answer never settled), so this line never claims it isn't there.
  WAITING: { icon: faHandPaper, cls: 'abacus-sync-btn--error', words: (r) => `${r.state_words}: ${r.reason}` },
  ERROR: { icon: faExclamationTriangle, cls: 'abacus-sync-btn--error', words: (r) => r.reason },
};

const AbacusStatus = ({ model, recordId }) => {
  const [row, setRow] = useState(null);

  useEffect(() => {
    if (!model || !recordId) return undefined;
    let cancelled = false;
    abacusService.checkRecordSyncStatus(model, recordId)
      .then((data) => {
        if (cancelled) return;
        const records = data.records || [];
        setRow(records.find((r) => r.state === 'SYNCED') || records[0] || null);
      })
      .catch(() => { if (!cancelled) setRow(null); });
    return () => { cancelled = true; };
  }, [model, recordId]);

  if (!row || !LOOK[row.state]) return null;
  const look = LOOK[row.state];
  return (
    <div className="abacus-sync-wrapper" role="status">
      <span className={`abacus-sync-btn abacus-sync-btn--sm ${look.cls}`} style={{ cursor: 'default' }}>
        <FontAwesomeIcon icon={look.icon} />
        <span className="abacus-sync-btn__label">{look.words(row)}</span>
      </span>
      {row.state !== 'SYNCED' && row.state !== 'PENDING' && (
        <Link to="/invoicing/abacus-sync" style={{ marginLeft: 8, fontSize: 12 }}>Fix it in the Abacus list</Link>
      )}
    </div>
  );
};

export default AbacusStatus;
